import { CRIAR_PAGINA_SITE, CARREGAR_PAGINAS_SERVER, DELETAR_PAGINA_SITE, EDITAR_PAGINA_SITE } from "../constants/constants";
import {database} from '../firebase'
import { doLoad, finishLoad } from "../actions/request";
import { carregarPaginasStore } from "../actions/paginas";

function objToArray(temp1){
    if(temp1==null) return []
    let tmp2 = []
	Object.keys(temp1).map(x => tmp2.push(temp1[x]))
	return tmp2;
}

export default ({dispatch}) => next => action =>{
    if(action.type == CRIAR_PAGINA_SITE || action.type == EDITAR_PAGINA_SITE) {
        dispatch(doLoad())
        database.ref('/paginas').once('value', n =>{
            let updates = {}
            updates['/paginas/'+action.id] = {nome : action.nome, conteudo : action.conteudo, id : action.id}
            database.ref().update(updates);
            dispatch(finishLoad())
        })  
    }

    if(action.type == DELETAR_PAGINA_SITE) {
        dispatch(doLoad())
        database.ref('/paginas').once('value', n =>{
            let updates = {}
            updates['/paginas/'] = n.val();
            delete updates['/paginas/'][action.id]
            database.ref().update(updates);
            dispatch(finishLoad())
        })  
    }

    if(action.type == CARREGAR_PAGINAS_SERVER){
        dispatch(doLoad())
        database.ref('/paginas').on('value', n =>{
            dispatch(finishLoad())
            let vn = n.val();
            if(!Array.isArray(vn))
                vn = objToArray(vn)                
            dispatch(carregarPaginasStore(vn));
        })
    }

    next(action);
}


// WEBPACK FOOTER //
// ./src/middlewares/paginas.js